var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editor"}},[_c('editorLongTop'),_c('div',{staticClass:"main",style:({ height: _vm.mianH + 'px' })},[_c('editorLongLeft'),_c('editorLongRight')],1),_c('vipPopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }